/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";


export const MunicipioSCH = (perPage = 1)=> {
    var filtro = new Filtro()
    filtro.perPage = perPage
    filtro.fields = ['nome', 'uf']
    filtro.addOrder('nome', 'asc')
  return filtro
}
